appHost.actions.register({
    // #region Vars
    name: '288a.commerce.cart.create',
    // #endregion
    // #region Entry
    async execute(data, params) {
        return this.Window(await appHost.notification.showModal2(appHost.components.getComponent('g-cart-create-dialog'), { ...data, ...params }));
    },
    // #endregion
});
export {};
